import lodash from 'lodash';

/**
 * Model for cumulative grade policy
 */
const DEFAULT_PASSING_THRESHOLD = 0.6;

export default class CumulativeGradePolicy {
  declare passingThreshold: number;

  declare trackPassingThresholds: {};

  constructor(passingThreshold = DEFAULT_PASSING_THRESHOLD, trackPassingThresholds = {}) {
    this.passingThreshold = passingThreshold;
    this.trackPassingThresholds = trackPassingThresholds;
  }

  get isMastery() {
    return false;
  }

  get isCumulative() {
    return true;
  }

  get isPassingThresholdValid() {
    return this.passingThreshold <= 1 && this.passingThreshold > 0;
  }

  clone = () => {
    const { passingThreshold, trackPassingThresholds } = lodash.cloneDeep(this);

    return new CumulativeGradePolicy(passingThreshold, trackPassingThresholds);
  };

  toJSON(this: CumulativeGradePolicy) {
    return {
      'org.coursera.ondemand.coursematerial.CumulativeGradePolicy': {
        ...this,
      },
    };
  }
}
